import { deepCopy } from '@/utils/toolkit/object/copy.utils';
import type { Period } from '../../interfaces/Building.interface';
import { type Actions, ActionType } from './dashboarding.actions';
import { initialState, type State } from './dashboarding.state';

export function dashboardingReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET:
            return initialState;

        case ActionType.SET_PERIODS: {
            const periods: Period[] = deepCopy(action.payload.periods);
            if (!periods || !periods.length) return { ...state, periods: [], selectedPeriod: null };
            else {
                const defaultPeriod = action.payload.defaultPeriod ? action.payload.defaultPeriod : state.lastSelectedPeriod;
                return {
                    ...state,
                    periods: action.payload.periods,
                    selectedPeriod:
                        defaultPeriod && periods.map(p => p.name).includes(defaultPeriod) ? defaultPeriod : (periods.shift()?.name ?? null)
                };
            }
        }

        case ActionType.SET_SELECTED_PERIOD: {
            const periods: Period[] = deepCopy(state.periods);
            const selectedPeriod: string | null = state.periods.map(p => p.name).includes(action.payload.periodId)
                ? action.payload.periodId
                : (periods.shift()?.name ?? null);
            return {
                ...state,
                selectedPeriod,
                lastSelectedPeriod: selectedPeriod
            };
        }

        case ActionType.SET_SELECTED_NODE_ID: {
            if (action.payload.selectedNodeId === state.selectedNodeId) {
                return state;
            } else {
                return {
                    ...state,
                    selectedNodeId: action.payload.selectedNodeId,
                    buildingIds: action.payload.buildingIds,
                    periods: [],
                    selectedPeriod: null
                };
            }
        }

        case ActionType.SET_SELECTED_DASHBOARD_ID: {
            if (action.payload.selectedDashboardId) {
                sessionStorage.setItem('SELECTED_DASHBOARD', action.payload.selectedDashboardId.toString());
            }
            return {
                ...state,
                selectedDashboardId: action.payload.selectedDashboardId
            };
        }

        case ActionType.FETCH_DASHBOARDS_SUCCEEDED: {
            return {
                ...state,
                dashboards: Array.isArray(action.payload.dashboards) ? action.payload.dashboards : [],
                areDashboardsLoaded: true
            };
        }

        case ActionType.FETCH_DASHBOARDS_FAILED: {
            return {
                ...state,
                dashboards: [],
                areDashboardsLoaded: false
            };
        }

        case ActionType.SET_ADMIN_MENU_ACTIVE: {
            sessionStorage.setItem('ADMIN_MENU_ACTIVE', String(action.payload.isAdminMenuActive));
            return {
                ...state,
                isAdminMenuActive: action.payload.isAdminMenuActive
            };
        }

        case ActionType.SET_IS_ESTIMATED_IGNORED_ON_WIDGETS: {
            return {
                ...state,
                isEstimatedIgnoredOnWidgets: action.payload
            };
        }

        default:
            return state;
    }
}
